import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PaymentModalComponent } from 'src/app/layouts/dash/modules/payment/payment-modal/payment-modal.component';
import { PaymentService } from 'src/app/services/payment.service';
import { OperationFinishedModalComponent } from '../../modals/operation-finished-modal/operation-finished-modal.component';
import { ResultComponent } from 'src/app/layouts/dash/modules/payment/result/result.component';

@Component({
  selector: 'app-confirm-pay-order',
  templateUrl: './confirm-pay-order.component.html',
  styleUrls: ['./confirm-pay-order.component.scss'],
})
export class ConfirmPayOrderComponent implements OnInit {
  public loading = false;
  buyOrder = '';
  orderData: any;

  constructor(
    private modalRef: BsModalRef,
    private paymentSvc: PaymentService,
    private sanitizer: DomSanitizer,
    private modalSvc: BsModalService
  ) {}

  ngOnInit(): void {
    this.getOrderData();
  }

  close() {
    this.modalRef.hide();
  }

  getOrderData() {
    this.loading = true;
    this.paymentSvc.getMyLastOrderPending().subscribe(
      (data) => {
        this.loading = false;
        this.orderData = data;
        console.log('LADATAAA: ' + this.orderData);
      },
      (error: any) => {
        this.loading = false;
      }
    );
  }

  pay(payBy: string) {
    this.loading = true;
    if (payBy == 'khipu') {
      this.paymentSvc.getPendingOrderKhipu(this.orderData.order._id).subscribe(
        (data) => {
          this.loading = false;
          this.buyOrder = data.buyOrder;
          this.openPaymentModal(data.url);
        },
        (error: any) => {
          this.loading = false;
        }
      );
    } else {
      this.paymentSvc
        .getPendingOrderTransBank(this.orderData.order._id)
        .subscribe(
          (data) => {
            this.loading = false;
            this.buyOrder = this.orderData.order._id;
            this.openTBPaymentModal(`${data.url}?token_ws=${data.token}`);
          },
          (error: any) => {
            this.loading = false;
          }
        );
    }
  }

  openPaymentModal(url: string) {
    let modal = this.modalSvc.show(PaymentModalComponent, {
      class: 'modal-lg modal-expanded-center modal-content-centered',
      initialState: {
        iframeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(url),
      },
    });
    let cancelTimer = setTimeout(() => {
      modal.hide();
      this.modalSvc.show(OperationFinishedModalComponent, {
        class: 'modal-lg modal-dialog-centered',
        initialState: {
          title: 'Operación fallida',
          content: 'Se agotó el tiempo para realizar esta operación.',
          successful: false,
        },
      });
    }, 600000);

    let timer = setInterval(() => {
      this.paymentSvc
        .resultPaymentKhipu(this.buyOrder)
        .subscribe(async (data) => {
          if (data.statusPay == 'PAY') {
            clearInterval(timer);
            clearInterval(cancelTimer);
            modal.hide();
            let lastModal = this.modalSvc.show(ResultComponent, {
              class: 'modal-content-centered',
              initialState: {
                token: this.buyOrder,
                method: 'khipu',
              },
            });

            lastModal.onHide?.subscribe(() => window.location.reload());
          }
        });
    }, 10000);
    modal.onHide?.subscribe(() => {
      setTimeout(() => {clearInterval(timer); }, 300000)
      clearInterval(cancelTimer);
    });
  }

  openTBPaymentModal(url: string) {
    let modal = this.modalSvc.show(PaymentModalComponent, {
      class: 'modal-lg modal-expanded-center modal-content-centered',
      initialState: {
        iframeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(url),
      },
    });
    let cancelTimer = setTimeout(() => {
      modal.hide();
      this.modalSvc.show(OperationFinishedModalComponent, {
        class: 'modal-lg modal-dialog-centered',
        initialState: {
          title: 'Operación fallida',
          content: 'Se agotó el tiempo para realizar esta operación.',
          successful: false,
        },
      });
    }, 600000);

    let timer = setInterval(() => {
      this.paymentSvc.resultPaymentTransBank(this.buyOrder).subscribe(
        (data) => {
          if (data?.statusPay === 'PAY') {
            clearInterval(timer);
            clearInterval(cancelTimer);
            modal.hide();
            //console.log("This buy order: " + this.buyOrder)
            let lastModal = this.modalSvc.show(ResultComponent, {
              class: 'modal-content-centered',
              initialState: {
                token: this.buyOrder,
                method: 'transbank',
              },
            });

            lastModal.onHide?.subscribe(() => window.location.reload());
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }, 10000);
    modal.onHide?.subscribe(() => {
      clearInterval(timer);
      clearInterval(cancelTimer);
    });
  }
}
